import { handleActions } from 'redux-actions';
import { Map } from 'immutable';
import { showNotification, hideNotification } from '../actions/notification_actions';

const initialState = Map({ show: false, message: '', id: 0 });

const componentReducers = handleActions(
  {
    [showNotification]: (state, { payload: { type = 'success', message } }) =>
      state
        .set('show', true)
        .set('message', message)
        .set('type', type)
        .update('id', id => id + 1),
    [hideNotification]: state => state.set('show', false),
  },
  initialState
);

export default componentReducers;



// WEBPACK FOOTER //
// ./src/reducers/notification_reducers.js